// Sample type choice on the Sample Collection grid. Pure helpers, no React.
// A test may be collected in more than one sample type (the server sends them in sampleTypeOptions, primary first).
// The dropdown starts on the test's own sample type; only a different pick is sent to the server.

export const defaultTypeOf = (sample) => {
  const options = sample?.sampleTypeOptions || [];
  if (options.some((o) => o.sampleTypeId === sample.sampleTypeId)) return sample.sampleTypeId;
  return (options.find((o) => o.isPrimary) || options[0])?.sampleTypeId;
};

/** The dropdown exists only for a test that can still be collected and has two or more sample types. Otherwise null. */
export const specimenChoiceFor = (sample, choices, onPick) => {
  const options = sample?.sampleTypeOptions || [];
  if (!sample || sample.isSampleCollected !== 'N' || options.length < 2) return null;
  return {
    options: options.map((o) => ({ value: o.sampleTypeId, label: o.sampleTypeName })),
    value: choices[sample.testId] ?? defaultTypeOf(sample),
    onChange: (value) => onPick(sample.testId, value),
  };
};

/** What the collection modal and the request carry for this test: only a type other than the default. */
export const chosenTypeFor = (sample, choices) => {
  const picked = choices[sample.testId];
  if (picked === undefined || picked === defaultTypeOf(sample)) return {};
  const option = (sample.sampleTypeOptions || []).find((o) => o.sampleTypeId === picked);
  return option ? { sampleTypeId: option.sampleTypeId, sampleTypeName: option.sampleTypeName } : {};
};
